import { FormField, Select } from '@/shared/components';
import type { ResourceOccupancyRow } from '@/shared/api';

/**
 * Wahl der Ressource im Sperren-Blatt – wenn es mehr als eine gibt oder die gewählte nicht mehr
 * aktiv ist; dann steht „Ressource wählen“ statt einer still vorgewählten anderen.
 */
export function ResourcePickField({
  rows,
  value,
  onChange,
}: {
  rows: ResourceOccupancyRow[];
  value: string;
  onChange: (row: ResourceOccupancyRow) => void;
}) {
  const known = rows.some((row) => row.resourceId === value);
  if (rows.length === 0 || (rows.length === 1 && known)) return null;
  return (
    <FormField label="Ressource" required>
      <Select
        value={known ? value : ''}
        onChange={(event) => {
          const next = rows.find((row) => row.resourceId === event.target.value);
          if (next) onChange(next);
        }}
      >
        {!known && (
          <option value="" disabled>
            Ressource wählen
          </option>
        )}
        {rows.map((row) => (
          <option key={row.resourceId} value={row.resourceId}>
            {row.name}
          </option>
        ))}
      </Select>
    </FormField>
  );
}
